import React, { useEffect, useState } from 'react'
import { Card, Input, Button, Table, Space, Pagination, Form, Select, message, Drawer, Modal, Upload, DatePicker } from 'antd'
import { FileSearchOutlined, UploadOutlined } from '@ant-design/icons';
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { getMatchCustomerListAPI, addMatchMobileAPI, addCustomerAPI, getAllFollowUpUserListAPI, getAccountInfoAPI, getClueHouseListAPI } from '@/apis/user'
import { checkMenu, checkLogin } from '@/utils'
import { getToken } from '@/utils/token'
import { baseURL } from '@/utils/request'
import Dayjs from 'dayjs'
import styles from './customerList.module.scss'
const { Column } = Table
const { TextArea } = Input
const { RangePicker } = DatePicker

export default function MatchCustomerList() {
  const navigate = useNavigate()
  const location = useLocation()

  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    phone: '',
    belongUserId: undefined, //	归属账号搜索筛选
    startTime: undefined, //	添加开始时间
    endTime: undefined,//  添加截至时间
    pageInt: 1,
    pageSize: 10
  })
  const [total, setTotal] = useState(0) //  列表总数
  const [list, setList] = useState([]) //  获取列表
  const [matchData, setMatchData] = useState({
    total: 0,
    success: 0,
  }) //  匹配统计
  const [belongUserList, setBelongUserList] = useState([]) //  归属账号列表
  const [mainHouseId, setMainHouseId] = useState(undefined) //  主楼盘id

  const [drawerStatus, setDrawerStatus] = useState(false) //  抽屉状态
  const [phoneFormLoading, setPhoneFormLoading] = useState(false) //  抽屉表单加载状态
  const [form] = Form.useForm();
  const [phoneFormData, setPhoneFormData] = useState({
    phones: ''
  }) //  抽屉表单

  const [modalStatus, setModalStatus] = useState(false) //  添加客户弹窗状态
  const [uploadData, setUploadData] = useState({
    loading: false,
    uploadStatus: false,
    fileName: '',
    total: 0,
    success: 0,
    fail: 0,
    fileUrl: ''
  }) //  上传文件数据

  //  翻页
  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }
  //  搜索
  const searchFinish = values => {
    listQuery.phone = values.phone
    listQuery.belongUserId = values.belongUserId

    let startTime = undefined
    let endTime = undefined
    if (values.endtime) {
      startTime = Dayjs(values.endtime[0]).format('YYYY-MM-DD')
      endTime = Dayjs(values.endtime[1]).format('YYYY-MM-DD')
    }
    listQuery.startTime = startTime
    listQuery.endTime = endTime
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }

  //  获取客资匹配列表
  const fetchData = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    setListLoading(true)
    const res = await getMatchCustomerListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.key = index
          item.addTime = Dayjs(item.addTime).format('YYYY-MM-DD')
          item.matchTime = item.matchTime && Dayjs(item.matchTime).format('YYYY-MM-DD')
          item.nickName = item.userId ? (item.nickName ? item.nickName : '暂无昵称' + item.userId.toString().slice(-4)) : ''
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
      setMatchData(res.result.match)
    }
    setListLoading(false)
  }
  //  获取账号详情
  const getAccountInfo = async () => {
    const res = await getAccountInfoAPI()
    if (res.success === true) {
      let list = []
      list.push({
        value: res.result.userId,
        label: res.result.userName + '（本账号）'
      })
      getAllFollowUpUserList(list)
    }
  }
  //  获取全部跟进人列表
  const getAllFollowUpUserList = async orginList => {
    const res = await getAllFollowUpUserListAPI()
    if (res.success === true) {
      let list = orginList || []
      res.result?.list?.forEach(item => {
        if(item.status === 1) {
          list.push({
            value: item.userId,
            label: item.nickName + '（下级）'
          })
        }
      })
      setBelongUserList(list)
    }
  }
  //  获取楼盘列表
  const getHouseList = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    const res = await getClueHouseListAPI({ pageInt: 1, pageSize: 10 })
    if (res.success === true) {
      setMainHouseId(res.result.mainHouseId ? res.result.mainHouseId[0] : 0)
    }
  }

  //  显示直查抽屉弹窗
  const changeDrawerStatus = () => {
    setDrawerStatus(!drawerStatus)
  }
  //  直查表单数据变更
  const changePhoneForm = (value) => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    if('phones' in value) {
      setPhoneFormData({
        ...phoneFormData,
        phones: value.phones
      })
    }
  }
  //  直查表单提交
  const submitPhoneForm = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    if(!phoneFormData.phones) {
      message.error('请输入手机号')
      return
    }
    let phonesObj = phoneFormData.phones.split(',')
    let phones = []
    if(phonesObj) {
      phonesObj.forEach(item => {
        let phone = item.split('，')
        if(phone) {
          phone.forEach(ele => {
            if(ele.length === 11) {
              phones.push(ele)
            }
          })
        }
      })
    }
    if(phones.length < 1) {
      message.error('一次至少匹配1个，请输入正确的手机号')
      return
    }
    if(phones.length > 50) {
      message.error('一次最多匹配50个')
      return
    }
    setPhoneFormLoading(true)
    const res = await addMatchMobileAPI({ phones: phones.join(',') })
    if (res.success === true) {
      message.success(res.result.successTotal + '个手机号匹配成功')
      phoneFormData.phones = ''
      setPhoneFormData({
        ...phoneFormData,
        phones: ''
      })
      form.resetFields()
      fetchData()
    } else {
      message.error(res.message)
    }
    setPhoneFormLoading(false)
  }
  //  导入窗口显示隐藏
  const changeModelStatus = () => {
    setModalStatus(!modalStatus)
    setUploadData({
      ...uploadData,
      loading: false,
      uploadStatus: false,
      total: 0,
      success: 0,
      fail: 0,
    })
  }
  const uploadProps = {
    action: baseURL + '/data/UploadMobileData', //  上传地址
    headers: {
      Token: getToken()
    },
    name: 'file',
    maxCount: 1,
    listType: 'none',
    disabled: uploadData.loading ? true : false,
    beforeUpload: file => {
      console.log('%c [ file ]-172', 'font-size:13px; background:pink; color:#bf2c9f;', file)
      const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!isXLSX) {
        message.error(`${file.name} is not a xlsx file`);
      }
      setUploadData({
        ...uploadData,
        fileName: file.name,
      })
      return isXLSX || Upload.LIST_IGNORE;
    },
    onChange: info => {
      if(info.file.status === 'done') {
        if(info.file.response.success === true) {
          setUploadData({
            ...uploadData,
            loading: false,
            uploadStatus: true,
            total: info.file.response.result.total,
            success: info.file.response.result.successTotal,
            fail: info.file.response.result.total - info.file.response.result.successTotal,
            fileUrl: info.file.response.result.fileUrl
          })
          fetchData()
        } else {
          message.error(info.file.response.message)
          setUploadData({
            ...uploadData,
            loading: false,
          })
        }
      } else {
        setUploadData({
          ...uploadData,
          loading: true,
        })
      }
    },
  }
  // const downloadTemplate = () => {
  //   const fileUrl = 'https://yblqoq.yuque.com/office/yuque/0/2025/xlsx/719272/1755337847549-fe33a16f-6cba-423b-bb78-ea75bf019c14.xlsx?from=https%3A%2F%2Fyblqoq.yuque.com%2Fqshcwh%2Fab4crm%2Ffmnehve4go09f1g4%3FsingleDoc%23%2520%25E3%2580%258AB%25E7%25AB%25AFbug%25E3%2580%258B'; // 替换为你的线上文件 URL
  //   //const filename = 'sample.pdf'; // 建议手动指定文件名

  //   try {
  //     const response = await fetch(fileUrl, {
  //       method: 'GET',
  //       // 如果需要鉴权，添加 headers
  //       headers: {
  //         // 'Authorization': 'Bearer your-jwt-token',
  //         // 'x-api-key': 'your-api-key'
  //       },
  //       // mode: 'cors', // 根据情况设置跨域模式
  //     });

  //     if (!response.ok) {
  //       throw new Error(`下载失败：${response.status} ${response.statusText}`);
  //     }

  //     // 将响应体转为 Blob
  //     const blob = await response.blob();

  //     // 创建临时下载链接
  //     const downloadUrl = window.URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = downloadUrl;
  //     link.download = filename; // 指定下载的文件名
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     // 释放内存
  //     window.URL.revokeObjectURL(downloadUrl);

  //     message.success('下载启动！');
  //   } catch (error) {
  //     console.error('下载出错:', error);
  //     message.error(`下载失败：${error.message}`);
  //   }
  // }
  //  添加客资
  const addCustomer = async (row) => {
    list[row.key].loading = true
    setList([...list])
    let isCustomer = row.isCustomer && row.isCustomer === 1 ? 0 : 1
    let params = {
      userId: row.userId,
      isCustomer,
      houseId: mainHouseId
    }
    if(!mainHouseId && isCustomer === 1) {
      message.error('暂无标星楼盘，请联系客服添加')
      list[row.key].loading = false
      setList([...list])
      return
    }
    const res = await addCustomerAPI(params)
    if (res.success === true) {
      message.success('加客资成功')
      fetchData()
    } else {
      message.error(res.message)
      list[row.key].loading = false
      setList([...list])
    }
  }

  useEffect(() => {
    if(!checkMenu(location.pathname)) {
      navigate('/managecenter/404')
      return
    }
    fetchData()
    getAccountInfo()
    getHouseList()
  }, [])

  return (
    <div>
      <div className="pageTitle">客资匹配</div>
      <Card className="card">
        <Form initialValues={listQuery} onFinish={searchFinish} className="searchForm">
          <Form.Item name="phone">
            <Input allowClear placeholder="手机号" style={{ width: '200px' }} />
          </Form.Item>
          <Form.Item name="belongUserId">
            <Select allowClear options={belongUserList} placeholder="归属账号" style={{ width: '250px', marginLeft: '10px' }} />
          </Form.Item>
          <Form.Item name="endtime">
            <RangePicker allowClear needConfirm picker="date" placeholder={['添加开始时间', '添加截止时间']} style={{ width: '300px', marginLeft: '10px' }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="searchBtn" htmlType="submit" style={{ marginLeft: '10px' }}>搜索</Button>
          </Form.Item>
        </Form>
        <div className='bg-fafafa padding-left-24 padding-right-24 line-height-40 flex-between font-size14 margin-bottom-12'>
          <div className='gray'>累计{matchData.total}，已匹配<span className='green'>{matchData.success}</span>（持续自动匹配）</div>
          <div className='flex-end'>
            <div className='flex-end cursor-pointer' onClick={changeDrawerStatus}>
              <FileSearchOutlined />
              <div className='margin-left-10'>直查</div>
            </div>
            <div className='flex-end margin-left-24 cursor-pointer' onClick={changeModelStatus}>
              <UploadOutlined />
              <div className='margin-left-10'>导入</div>
            </div>
          </div>
        </div>
        <Table dataSource={list} loading={listLoading} pagination={false}>
          <Column title="匹配结果" dataIndex="nickName" />
          <Column title="手机号" dataIndex="phone" />
          <Column
            title="归属账号"
            className="gray"
            render={(_, record) => (
              <Space size="middle">
                {record.belongUserName + (record.belongUserPlatform ? '（小程序）' : '（PC端）')}
              </Space>
            )}
          />
          <Column
            title="上级账号"
            className="gray"
            render={(_, record) => (
              <Space size="middle">
                {record.seniorUserName + (record.seniorUserPlatform ? '（小程序）' : '（PC端）')}
              </Space>
            )}
          />
          <Column
            title="来源说明"
            className="gray"
            render={(_, record) => (
              record.sourceType ? '导入' : '直查'
            )}
          />
          <Column title="添加时间" dataIndex="addTime" className="gray" />
          <Column title="匹配时间" dataIndex="matchTime" className="gray" />
          <Column
            title="操作"
            key="action"
            render={(_, record) => (
              record.userId ? (
                <Space size="middle">
                  <Link target="_blank" to={'/managecenter/user/detail/' + record.userId} className="color-576b95">
                    画像
                  </Link>
                  {Number(record.isCustomer) == 1 ? (
                    <span className="gray">已加客资</span>
                  ) : (
                    <Button type="link" loading={record.loading} onClick={() => addCustomer(record)} className="color-576b95">加客资</Button>
                  )}
                </Space>
              ) : ''
            )}
          />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
      <Modal title="导入数据" closable={true} open={modalStatus} footer={null} onCancel={changeModelStatus}>
        <div style={{height: '400px'}}>
          <div className='flex align-items margin-top-24'>
            <Upload {...uploadProps} >
              <Button size='large' className='white bg-green'>选择文件</Button>
            </Upload>
            <a className='color-576b95 font-size16 margin-left-24' href="/匹配电话导入模版.xlsx" download>下载导入模板</a>
          </div>
          <div className='margin-top-24 line-height-24 font-size16'>
            <div>说明：</div>
            <div>1、支持导入格式为xlsx的文件(手动修改文件后缀无效)。</div>
            <div className='red'>2、模板的表头不可更改，不可删除。</div>
            <div>3、数据不超过<span className='red'>1000</span>条。</div>
            <div>4、如导入的新数据和已有数据重复，将覆盖老数据。</div>
          </div>
          {uploadData.loading ? (
            <div className='margin-top-24 line-height-24 font-size16 color-999999'>处理中…</div>
          ) : ''}
          {uploadData.uploadStatus ? (
            <div className='margin-top-24 line-height-24 font-size16'>
              <div>导入结果：</div>
              <div>文件名称：{uploadData.fileName}</div>
              <div>成功导入：{uploadData.total}条数据</div>
              <div>已匹配：<span className='green'>{uploadData.success}</span>条数据</div>
              <div>暂无匹配：<span className='red'>{uploadData.fail}</span>条数据</div>
              <div className='margin-top-16'><Link className='color-576b95' target='_blank' to={uploadData.fileUrl}>下载失败详情</Link></div>
            </div>
          ) : ''}
        </div>
      </Modal>
      <Drawer closeIcon={false} open={drawerStatus} onClose={changeDrawerStatus}>
        <div className={styles['dynamic-top']}>
          <div className={styles['userinfo']}>
            <span className={styles['nickname']}>客资匹配-直查</span>
          </div>
          <div className={styles['close']} onClick={changeDrawerStatus}>
            关闭
          </div>
        </div>
        <Form form={form} initialValues={phoneFormData} onValuesChange={changePhoneForm} onFinish={submitPhoneForm}>
          <Form.Item name="phones">
            <TextArea rows={20} placeholder="多个手机号之间请使用逗号“，”隔开，
最多支持50个手机号，
大于50请使用使用“导入”功能。
13888888888，13555555555，…" />
          </Form.Item>
          <Form.Item>
            <Button block size="large" htmlType="submit" loading={phoneFormLoading} className={[styles['submitBtn'], 'bg-green', 'white', 'padding-top-10', 'padding-bottom-10', 'font-size16', 'line-height-24'].join(' ')}>
              {phoneFormLoading ? '处理中...' : '开始匹配'}
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  )
}
